var parameterInsert={
    IdUser:'',
    IdDocType:'',
    IdDocCategory:'',
    IdEnterprise:'',
    IdFrequency:'',
    Quantity:'',
    Period:'', 
    Month:[],
    Active:'1', 
    User:'',
    IP:''
} 
var parameterUpdate={
    IdGoal:'', 
    Quantity:'', 
    Active:'1', 
    User:'',
    IP:''
} 
var parameterView={ 
    IdEnterprise:'',
    Active:'1'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}